export default {
	methods: {
		clickExcluirAbastecimento(item, index) {
			if (item.id == 0) {
				this.form.splice(index, 1)
			} else {
				const texto = `
      			<h3> 
					<span class='text-danger'>${_traducao('global', 'desejaExcluirAbastecimento')}
					</span> <br/> <br/> ${_traducao('global', 'excluirAbastecimento')} 
				</h3> `;
				this._modalExcluir(
					(retorno) => {
						if (retorno.excluir) {
							this.excluirAbastecimento(retorno.obj, index)
						}
					},
					item,
					texto,
					this._traducao('global', 'excluir').toUpperCase()
				)
			}
		},

		excluirAbastecimento(item, index) {
			bus.$emit('load-in', {text: this._traducao('global', 'excluindo')})
			this._axios(
				`mg-siga/Relatorio_voo_trecho/excluir_abastecimento/${item.id}`,
				'get',
				{
					callback: (retorno) => {
						if (retorno.status == 'sucesso') {
							bus.$emit('exibir-notificacao', {
								type: 'success',
								text: 'Abastecimento excluído com sucesso'
							})
							this.form.splice(index, 1)
							this.adicionarAbastecimento()
							return
						}
					},
					finally: () => {
						bus.$emit('load-out')
					}
				}
			)
		},
		adicionarAbastecimento() {
			this.form.existe_abastecimento = '1'

			if (this.form.length <= 0) {
				this.clickAddAbastecimento()
			}
		},
		clickAddAbastecimento() {
			this.form.push({
				anexos: [],
				combustiveis: [],
				contratos: [],
				contratoSelecionado: {},
				data_abastecimento: null,
				designativo_abastecimento: 'origem',
				empenhos: [],
				empenhoSelecionado: {},
				erro: {
					designativo_abastecimento: null,
					id_contrato: null,
					id_contrato_empenho: null,
					id_fornecedor: null,
					id_tipo_lancamento: null,
					numero_ce: null,
					origem_abastecimento: null,
					relacao_abastecimento: null,
					valor_total: null,
					valor_unitario: null,
					volume: null,
				},
				forma_controle: null,
				id: 0,
				id_combustivel: null,
				id_contrato_empenho: null,
				id_fornecedor: null,
				id_orgao: null,
				id_tipo_lancamento: null,
				id_unidade_armazenamento: null,
				nota_fiscal: null,
				numero_ce: null,
				relacao_abastecimento: null,
				unidadeArmazenamentoSelecionada: {},
				valor_total: 0,
				valor_unitario: 0,
				volume: 0,
			})
			this.criarRegistroDeAbastecimento()
		},
		criarRegistroDeAbastecimento() {
			const idRelatorio = this.trecho.id
			const dadosAbastecimento = this.form
			this._axios(
				`mg-siga/Relatorio_voo_trecho/criar_registro_abastecimento/${idRelatorio}`,
				'post',
				{
					data: {
						dadosAbastecimento
					},
					callback: (response) => {
						if (response._request) {
							const ids = response.ids
							if (Array.isArray(ids) && ids.length > 0) {
								ids.forEach((id, index) => {
									this.form.splice(index, 1, {
										...this.form[index],
										id: id
									})
								})
							}
						}
					}
				}
			)
		},
		abrirCadastroFornecedor() {
			this.$refs.modalCadastroFornecedoresRef.abrirModalFornecedor()
		},
		uploadFiles(indexAbastecimento, files) {
			this.form[indexAbastecimento].anexos = this.form[
				indexAbastecimento
			].anexos.filter((existingFile) => {
				return files.some(
					(newFile) => newFile.nomeTemp === existingFile.nomeTemp
				)
			})

			files.forEach((item) => {
				if (!item.id) {
					const duplicado = this.form[indexAbastecimento].anexos.some(
						(doc) =>
							doc.nomeTemp === item.nomeTemp ||
							doc.nomeTemp === item.hash_arquivo
					)
					if (!duplicado) {
						this.form[indexAbastecimento].anexos.push({
							id_abastecimento_trecho: this.form[indexAbastecimento].id,
							ext: item.ext,
							icone: item.icone,
							nome: item.nome,
							nomeTemp: item.nomeTemp ? item.nomeTemp : item.hash_arquivo,
							tamanho: item.tamanho
						})
					}
				}
			})
		},
		loadImageAbastecimento(imgString) {
			const {id} = this.form[this.abastecimentoIndex]
			try {
				this._axios(
					'mg-siga/Relatorio_voo_trecho/get_photo_db_abastecimento',
					'post',
					{
						data: {imgString, id},
						callback: (response) => {
							if (response._request) {
								this.showCamera = false
								const anexoAbastecimento = response.lista
								this.loadedFiles.push({
									id: anexoAbastecimento.id,
									nome: anexoAbastecimento.nome,
									link: anexoAbastecimento.link,
									ext: anexoAbastecimento.ext
								})
								this.form[
									this.abastecimentoIndex
								].anexos = this.loadedFiles
								this.$nextTick(() => {
									if (this.$refs.anexos) {
										this.$refs.anexos[this.abastecimentoIndex].carregaLista(
											this.loadedFiles
										)
									}
								})
							}
						}
					}
				)
			} catch (error) {
				alert(error)
			}
		},
		openCamera(index) {
			this.abastecimentoIndex = index
			this.showCamera = true
		},
		openCameraAnexos() {
			this.showCameraAnexos = true
		},		
		closeCamera() {
			this.showCamera = false
		},
		closeCameraAnexos() {
			this.showCameraAnexos = false
		},

		alteraDataAbastecimento(designativoAbastecimento, index) {
			this.form[index].data_abastecimento = ''
			if (designativoAbastecimento == 'origem') {
				this.form[index].data_abastecimento =
					this.form.acionamento
			} else if (designativoAbastecimento == 'destino') {
				this.form[index].data_abastecimento =
					this.form.corte
			}
		},
	}
}


